import React, { useCallback } from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { useModalContext } from '@bcraft-frontend-lib/core'
import block from 'bem-cn'

import { ROUTE_URLS } from 'router/routes'

import freeSpinEndImg from 'shared/img/freeSpinEnd.svg'
import { ReactComponent as CloseImg } from 'shared/img/modal-close.svg'

import { BonusPromotionStatus } from 'shared/models/Promotion'

import { selectLocaleDict } from 'features/locale/selectors'

import { Button, ButtonSizes } from 'components/UIKit'

import './FreeSpinEndModal.scss'

const b = block('free-spin-end-modal')

export const FreeSpinEndModal: React.FC<{ path: string }> = ({ path }) => {
  const history = useHistory()
  const { closeModal } = useModalContext()
  const locale = useSelector(selectLocaleDict, shallowEqual)

  const onClose = useCallback(() => {
    closeModal(path)()
  }, [closeModal, path])

  const onPromotionsClick = useCallback(() => {
    onClose()
    history.push(ROUTE_URLS.PROFILE_PROMOTIONS_STATUS(BonusPromotionStatus.active))
  }, [history, onClose])

  return (
    <div className={b()}>
      <div className={b('header')}>
        <CloseImg className={b('close')} onClick={onClose} />
      </div>

      <div className={b('content')}>
        <div className={b('title')}>{locale.slots.sessionEnd}</div>
        <img src={freeSpinEndImg} className={b('img')} alt="" />
        <Button
          text={locale.profile.promotions}
          onClick={onPromotionsClick}
          uppercase
          fullWidth
          size={ButtonSizes.LARGE}
        />
      </div>
    </div>
  )
}
